import { customHeaders, requestApi } from 'api/api'
import { v4 as uuidv4 } from 'uuid'
import {
  PayoutsFeeEstimateResponse,
  PayoutsV2PostAuthRequest,
  PayoutsV2PostAuthResponse,
  PayoutsV2PreAuthRequest,
  PayoutsV2PreAuthResponse,
} from 'types/payoutsV2'
import { PayoutRequest } from 'types/unifiedPayouts/unifiedPayouts'

export const postPayoutsV2PreAuth = (
  data: PayoutsV2PreAuthRequest
): Promise<PayoutsV2PreAuthResponse> => {
  return requestApi({
    url: '/v2/fiat/pay/wallet',
    method: 'POST',
    data,
    headers: {
      ...customHeaders,
      'x-idempotency-key': uuidv4(),
    } as any,
  })
}

export const postPayoutsPostAuthV2 = (
  data: PayoutsV2PostAuthRequest
): Promise<PayoutsV2PostAuthResponse> => {
  return requestApi({
    url: '',
    baseUrl: data?.mfaCallbackUrl,
    method: 'POST',
    data: {
      challenge: data?.challenge,
      tokenResponse: data?.tokenResponse,
    },
    headers: {
      'x-idempotency-key': uuidv4(),
    } as any,
  })
}

export const getPayoutsFeeEstimate = (data: PayoutRequest): Promise<PayoutsFeeEstimateResponse> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: '/payment/v1/payouts/estimate',
    method: 'POST',
    data,
  })
}
